module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9 5"},"content":"<path fill=\"#999\" fill-rule=\"evenodd\" d=\"M.2.2C-.1.4-.1.8.2 1L4 4.8c.3.3.7.3 1 0l3.8-3.7c.3-.3.3-.7 0-1a.7.7 0 0 0-1 0L4.5 3.4 1.2.2a.7.7 0 0 0-1 0z\"/>"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-arrow-down.svg
// module id = 228
// module chunks = 0